import React from 'react';
import { Ticker, TickerLink } from '@benzinga/ticker-ui';
//import { formatPrice } from '@benzinga/calendars';
import { Ratings } from '@benzinga/calendar-manager';
import { formatPrice } from '@benzinga/utils';

export const RatingsColumnsDef = [
  {
    cellRenderer: ({ data }: { data: Ratings }) => {
      return (
        <Ticker
          symbol={data.ticker}
          targetElement={
            <TickerLink slug="analyst-ratings" symbol={data.ticker}>
              {data.ticker}
            </TickerLink>
          }
        />
      );
    },
    field: 'ticker',
    headerName: 'Ticker',
  },
  {
    cellClass: 'semibold',
    cellRenderer: ({ data }: { data: Ratings }) => {
      return (
        <Ticker
          symbol={data.ticker}
          targetElement={
            <TickerLink slug="analyst-ratings" symbol={data.ticker}>
              {data.name}
            </TickerLink>
          }
        />
      );
    },
    colSpan: 3,
    field: 'name',
    headerName: 'Company',
  },
  {
    colSpan: 3,
    field: 'analyst',
    headerName: 'Analyst',
  },
  {
    colSpan: 3,
    field: 'rating_current',
    headerName: 'Rating',
  },
  {
    cellClass: 'semibold',
    colSpan: 2,
    field: 'pt_current',
    headerName: 'Price Target',
    valueFormatter: ({ data }: { data: Ratings }) => {
      if (data.pt_current) {
        return `$${formatPrice(Number(data.pt_current))}`;
      }
      return '—';
    },
  },
];

export default RatingsColumnsDef;
